<div class="breadcrumbLayout">
  <kendo-breadcrumb [items]="breadCrumbs" [separatorSVGIcon]="breadCrumbSeparator" (itemClick)="onBreadCrumbClicked($event)"></kendo-breadcrumb>
</div>
<div class="toolbarLayout">
  <app-tool-bar [items]="toolbarItems"></app-tool-bar>
</div>
<kendo-stacklayout [gap]="20" orientation="horizontal" class="searchLayout">
  <div class="searchContainer">
    <input type="hidden" id="isSearchVisible" value="true" />
    <div class="searchCollapse">
      <button kendoButton id="btnMenu" [svgIcon]="menu" [title]="menuButtonTitle" (click)="collapseSearchContainer('collapse')"></button>
    </div>
    <div class="searchParent">
      <div class="searchContent">
        @for (view of views; track view.title) {
        @for (group of view.controls; track group.id) {
        <kendo-expansionpanel [title]="toGroup(group).name" [expanded]="true">
          @for (row of toGroup(group).rows; track row) {
          @for (control of row.controls; track control.id) {
          <div class="control-group">
            <div class="control-label" [hidden]="!control.isVisible">
              <kendo-label>{{ control.label }} {{ getIsRequired(control) }}</kendo-label>
            </div>
            @switch (control.className) {
            @case('TextAreaControl') {
            <div class="control-element" [hidden]="!control.isVisible">
              <kendo-textarea id="{{ control.id }}" [rows]="3" [(ngModel)]="toTextArea(control).value"></kendo-textarea>
            </div>
            }
            @case('TextControl') {
            <div class="control-element" [hidden]="!control.isVisible">
              <kendo-textbox id="{{ control.id }}" [(ngModel)]="toText(control).value"></kendo-textbox>
            </div>
            }
            @case('ToggleControl') {
            <div class="control-element" [hidden]="!control.isVisible">
              <input type="checkbox" kendoCheckBox [(ngModel)]="toToggle(control).value" />
            </div>
            }
            @case('DateControl') {
            <div class="control-element" [hidden]="!control.isVisible">
              <kendo-datepicker id="{{ control.id }}" calendarType="infinite" [(ngModel)]="toDate(control).value"></kendo-datepicker>
            </div>
            }
            @case('NumericControl') {
            <div class="control-element" [hidden]="!control.isVisible">
              <kendo-numerictextbox id="{{ control.id }}" [(ngModel)]="toNumeric(control).value" [decimals]="toNumeric(control).decimals" [format]="toNumeric(control).format"></kendo-numerictextbox>
            </div>
            }
            <!-- Keep Select Controls at the bottom and as the default switch case -->
            @default {
            <div class="control-element" [hidden]="!control.isVisible">
              <app-select-field [control]="control" (onChange)="onSelectChange(control, $event)"></app-select-field>
            </div>
            }
            }
          </div>
          }
          }
        </kendo-expansionpanel>
        }
        }
      </div>
    </div>
  </div>
  <div class="gridContainer">
    <app-grid [apiController]="apiController" [keyFieldName]="keyFieldName" [data]="data" [gridSettings]="gridSettings"></app-grid>
  </div>
</kendo-stacklayout>
